import type {
  SignalCategoryType,
  TargetTypeType,
} from '@terra/shared-schemas-orchestrator';
import {
  normalizeMcpServerSignalCategoriesInScope,
  resolveStoredSignalCategoriesInScope,
  type SignalCategoryTargetType,
} from '@terra/ui-design-system';

export const toSignalCategoryTargetType = ({
  targetType,
  isMcpServerTarget,
}: {
  targetType: TargetTypeType | undefined;
  isMcpServerTarget: boolean;
}): SignalCategoryTargetType =>
  isMcpServerTarget ? 'MCP_SERVER' : (targetType ?? 'WEB_APPLICATION');

export const usesResolvedSignalCategoryScope = (
  targetType: SignalCategoryTargetType,
): boolean =>
  targetType === 'AI_APPLICATION' ||
  targetType === 'AGENTIC_AI' ||
  targetType === 'MCP_SERVER';

export const resolveTargetSignalCategoriesInScope = ({
  stored,
  targetType,
}: {
  stored: SignalCategoryType[];
  targetType: SignalCategoryTargetType;
}): SignalCategoryType[] => {
  if (!usesResolvedSignalCategoryScope(targetType)) {
    return stored;
  }

  if (targetType === 'MCP_SERVER') {
    return normalizeMcpServerSignalCategoriesInScope({ stored });
  }

  return resolveStoredSignalCategoriesInScope({
    stored,
    targetType: 'AI_APPLICATION',
  });
};
